import request from "@/utils/request";
import qs from 'qs'

export function login(data) {
    return request({
        url: "/api/login",
        method: "post",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset-utf-8"
        },
        data: qs.stringify(data)
    });
}

export function logout(params) {
    return request({
        url: "/api/logout",
        method: "post",
        data: params
    });
}

export function getLoggedInUser(param) {
    return request({
        url: "/api/get-login-user",
        method: "get",
        params: param,
    });
}

export function getBranch(params) {
    return request({
        url: "/api/get-branches",
        method: "get",
        params: params,
    });
}

export function getCert() {
    return request({
        url: "/api/get-cert",
        method: "get",
    });
}

export function getRequest(param) {
    return request({
        url: "/api/get-request",
        method: "get",
        params: param
    });
}

export function getCompany(params) {
    return request({
        url: "/api/get-company",
        method: "get",
        params: params
    });
}

export function checkValidEmail(params) {
    return request({
        url: "/api/check-email",
        method: "get",
        params: params
    });
}

export function checkValidLogin(params) {
    return request({
        url: "/api/check-login",
        method: "get",
        params: params
    })
}

